/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, Optional} from '@angular/core';
import {ExpandableRowsCount} from './providers/global-expandable-rows';
export class DatagridDetailRegisterer {
/**
 * @param {?} expandableRowsCount
 */
constructor(
private expandableRowsCount: ExpandableRowsCount) {
        if (this.expandableRowsCount) {
            this.expandableRowsCount.register();
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        if (this.expandableRowsCount) {
            this.expandableRowsCount.unregister();
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrIfExpanded]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ExpandableRowsCount, decorators: [{ type: Optional }, ]},
];
}

function DatagridDetailRegisterer_tsickle_Closure_declarations() {
/** @type {?} */
DatagridDetailRegisterer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridDetailRegisterer.ctorParameters;
/** @type {?} */
DatagridDetailRegisterer.prototype.expandableRowsCount;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
